<template>
  <Wrap>
    <CoreBreadcrumbs
      v-if="list.length"
      :list="breadcrumbs"
      :events-identifier="MF_NAME"
    />
    <SkeletonItem
      v-else
      class="skeleton"
    />
  </Wrap>
</template>

<script lang="ts" setup>
  import { UiBreadcrumbs as CoreBreadcrumbs, type IUiBreadcrumbItem } from '@experience/core-breadcrumbs-ui';
  import { SkeletonItem } from '@experience/core-skeleton-lib';
  import { computed } from 'vue';

  import { MF_NAME } from '@/shared/consts';
  import Wrap from '@/shared/ContentWrap.vue';
  import { type BreadcrumbsList } from '@/shared/models/types';

  const props = defineProps<{
    list: BreadcrumbsList[];
  }>();

  const breadcrumbs = computed<IUiBreadcrumbItem[]>(() =>
    props.list.map((item) => ({ label: item.label, to: item.href ?? '' })),
  );
</script>

<style lang="scss" scoped>
  @use '@experience/shared/dist/assets/adaptivity' as legacy-adaptivity;

  .skeleton {
    width: 460px;
    height: 40px;
    border-radius: var(--alias-radius-8);

    @include legacy-adaptivity.mobile {
      width: 230px;
    }
  }
</style>
